export const JOB_APPROVAL_MESSAGES = {
  APPROVE_SUCCESS: {
    key: 'APPROVE_SUCCESS',
    value: 'Job approved and scheduled for execution',
  },
  APPROVE_FAILED: {
    key: 'APPROVE_FAILED',
    value: 'Failed to approve job',
  },
  APPROVE_ERROR: {
    key: 'APPROVE_ERROR',
    value: 'Error approving job',
  },
  BATCH_NOT_FOUND: {
    key: 'BATCH_NOT_FOUND',
    value: 'Batch does not exist',
  },
  INVALID_STATE: {
    key: 'INVALID_STATE',
    value: 'Batch is not in pending approval state',
  },
  NOT_AUTHORIZED: {
    key: 'NOT_AUTHORIZED',
    value: 'You are not authorized to approve this batch',
  },
};

export const JOB_DISCARD_STATUS = {
  DISCARD_SUCCESSFUL:{key:'DISCARD_SUCCESSFUL' ,value: 'Job discarded successfully'},
  JOB_DOESNOT_EXIST:{key:'JOB_DOESNOT_EXIST', value :'Job does not exist'},
  JOB_DISCARD_FAILED:{key:'JOB_DISCARD_FAILED', value: 'Job cannot be discarded after submission'},
  JOB_DISCARD_FAILURE_MSG:{key: 'JOB_DISCARD_FAILURE_MSG', value:'Not able discard the draft at the moment. Please try again later'}
}


export const JOB_ABORT_MESSAGES = {
  ABORT_SUCCESS: {
    key: 'ABORT_SUCCESS',
    value: 'Batch aborted successfully',
  },
  ABORT_FAILED: {
    key: 'ABORT_FAILED',
    value: 'Failed to abort batch',
  },
  ABORT_ERROR: {
    key: 'ABORT_ERROR',
    value: 'Error aborting batch',
  },
  BATCH_NOT_FOUND: {
    key: 'BATCH_NOT_FOUND',
    value: 'Batch does not exist',
  },
  ALREADY_STARTED_OR_COMPLETED: {
    key: 'ALREADY_STARTED_OR_COMPLETED',
    value: 'Batch is already started or completed',
  },
};

export const JOB_REJECT_MESSAGES = {
  REJECT_SUCCESS: {
    key: 'REJECT_SUCCESS',
    value: 'Batch rejected successfully',
  },
  REJECT_FAILED: {
    key: 'REJECT_FAILED',
    value: 'Failed to REJECT batch',
  },
  REJECT_ERROR: {
    key: 'REJECT_ERROR',
    value: 'Error aborting batch',
  },
  BATCH_NOT_FOUND: {
    key: 'BATCH_NOT_FOUND',
    value: 'Batch does not exist',
  },
  ALREADY_STARTED_OR_COMPLETED: {
    key: 'ALREADY_STARTED_OR_COMPLETED',
    value: 'Batch is already started or completed',
  },
  NOT_AUTHORIZED: {
    key: 'NOT_AUTHORIZED',
    value: 'You are not authorized to approve this batch',
  }
}

export const JOB_RESCHEDULE_MESSAGES = {
  RESCHEDULE_SUCCESS: {
    key: 'RESCHEDULE_SUCCESS',
    value: 'Batch rescheduled successfully',
  },
  RESCHEDULE_FAILED: {
    key: 'RESCHEDULE_FAILED',
    value: 'Failed to reschedule batch',
  },
  RESCHEDULE_ERROR: {
    key: 'RESCHEDULE_ERROR',
    value: 'Error rescheduling batch',
  },
  MISSING_DATE_TIME: {
    key: 'MISSING_DATE_TIME',
    value: 'Please enter both date and time',
  },
  BATCH_NOT_FOUND: {
    key: 'BATCH_NOT_FOUND',
    value: 'Batch does not exist',
  },
  ALREADY_STARTED_OR_COMPLETED: {
    key: 'ALREADY_STARTED_OR_COMPLETED',
    value: 'Batch is already started or completed',
  },
};

export const JOB_DETAILS_UI = {
  DISCARD_CONFIRMATION:{key:'DISCARD_CONFIRMATION', value: 'Are you sure you want to discard this job?'},
  CANCEL_CONFIRMATION: { key: 'CANCEL_CONFIRMATION', value: 'Are you sure you want to cancel "{{name}}"?' },
  CANCEL_SUCCESS: { key: 'CANCEL_SUCCESS', value: 'Job cancelled successfully' },
  REJECT_SUCCESS: { key: 'REJECT_SUCCESS', value: 'The batch process has been rejected.' },
  REJECT_FAILURE: { key: 'REJECT_FAILURE', value: 'Failed to reject the batch.' },
  REJECTION_COMMENT_MANDATORY: { key: 'REJECTION_COMMENT_MANDATORY', value: 'Rejection comment is mandatory'},
  ABORT_COMMENT_MANDATORY: { key: 'ABORT_COMMENT_MANDATORY', value: 'Abort reason is required'},
  JOB_DETAILS_TAB: { key: 'JOB_DETAILS_TAB', value: 'Job Details' },
  PROOFS_PREVIEW_TAB: { key: 'PROOFS_PREVIEW_TAB', value: 'Proofs Preview' },
  JOB_STATUS_TAB: { key: 'JOB_STATUS_TAB', value: 'Job Status' },
  DRAFT_HEADER: { key: 'DRAFT_HEADER', value: 'Job Setup Incomplete' },
  DRAFT_DESCRIPTION: {
    key: 'DRAFT_DESCRIPTION',
    value:
      'This advanced job has only completed step {{currentStep}} of {{totalSteps}}. Continue editing to complete the remaining steps and submit the job.',
  },
  HYBRID_BATCH_DRAFT_DESCRIPTION: {
    key: 'HYBRID_BATCH_DRAFT_DESCRIPTION',
    value:
      'Letter split has been successfully completed. You may proceed with processing the job.',
  },
  CONTINUE_EDITING: { key: 'CONTINUE_EDITING', value: 'Continue Editing' },
  CONTINUE_PROCESSING: { key: 'CONTINUE_PROCESSING', value: 'Continue processing' },
  DISCARD_DRAFT: { key: 'DISCARD_DRAFT', value: 'Discard Draft' },
  SETUP_PROGRESS: { key: 'SETUP_PROGRESS', value: 'Setup Progress' },
  STEP_PROGRESS: {
    key: 'STEP_PROGRESS',
    value: 'Step {{currentStep}} of {{totalSteps}} completed',
  },
  SAVED_DETAILS: { key: 'SAVED_DETAILS', value: 'Saved Details' },
  JOB_NAME: { key: 'JOB_NAME', value: 'Job Name' },
  JOB_TYPE: { key: 'JOB_TYPE', value: 'Job Type' },
  DELIVERY_CHANNEL: { key: 'DELIVERY_CHANNEL', value: 'Delivery Channel' },
  CREATED: { key: 'CREATED', value: 'Created' },
  CREATED_DATE: { key: 'CREATED_DATE', value: 'Created Date' },
  CREATED_TIME: { key: 'CREATED_TIME', value: 'Created Time' },
  SCHEDULE_CONFIGURATION: { key: 'SCHEDULE_CONFIGURATION', value: 'Schedule Configuration' },
  SCHEDULED_DATE: { key: 'SCHEDULED_DATE', value: 'Scheduled Date' },
  SCHEDULED_TIME: { key: 'SCHEDULED_TIME', value: 'Scheduled Time' },
  ADDITIONAL_DETAILS: { key: 'ADDITIONAL_DETAILS', value: 'Additional Details' },
  DATA_FILE: { key: 'DATA_FILE', value: 'Data File' },
  LANGUAGE: { key: 'LANGUAGE', value: 'Language' },
  FORM_VARIABLES: { key: 'FORM_VARIABLES', value: 'Form Variables' },
  TEMPLATE: { key: 'TEMPLATE', value: 'Template' },
  TEMPLATE_CATEGORY: { key: 'TEMPLATE_CATEGORY', value: 'Template Category' },
  UPLOADED_FILE: { key: 'UPLOADED_FILE', value: 'Uploaded File' },
  RECORD_COUNT: { key: 'RECORD_COUNT', value: 'Record Count' },
  SPLIT_CRITERIA: { key: 'SPLIT_CRITERIA', value: 'Split Criteria' },
  ADDRESS: { key: 'ADDRESS', value: 'Address' },
  PAGE_COUNT: { key: 'PAGE_COUNT', value: 'Page Count' },
  ENVELOPE_TYPE: { key: 'ENVELOPE_TYPE', value: 'Envelope Type' },
  STATIONARY_NAME: { key: 'STATIONARY_NAME', value: 'Stationary Name' },
  INSERT_NAME: { key: 'INSERT_NAME', value: 'Insert Name' },
  DELIVERY_CLASS: { key: 'DELIVERY_CLASS', value: 'Delivery Class' },
  LETTER_COUNT: { key: 'LETTER_COUNT', value: 'Letter Count' },
  APPROVAL_REQUIRED: { key: 'APPROVAL_REQUIRED', value: 'Approval Required' },
  APPROVAL_DESCRIPTION1: {
    key: 'APPROVAL_DESCRIPTION1',
    value:
      'This job requires approval before execution.',
  },
  APPROVAL_DESCRIPTION2: {
    key: 'APPROVAL_DESCRIPTION2',
    value:
      'Review the job details below and approve or reject.',
  },
  SCHEDULED_TITLE: { key: 'SCHEDULED_TITLE', value: 'Job is scheduled' },
  SCHEDULED_DESCRIPTION: {
    key: 'SCHEDULED_DESCRIPTION',
    value:
      'This job is scheduled and awaiting execution. You may {{feature}} it before it begins.',
  },
  REJECTION_COMMENT: {
    key: 'REJECTION_COMMENT',
    value: 'Provide Your Comments'
  },
  CONFIRM_BUTTON: {
    key: 'CONFIRM_BUTTON',
    value: 'Confirm'
  },
  APPROVER_LABEL: { key: 'APPROVER_LABEL', value: 'Approver' },
  APPROVE: { key: 'APPROVE', value: 'Approve' },
  ABORT: { key: 'ABORT', value: 'Abort' },
  ABORTED_BY: { key: 'ABORTED_BY', value: 'Aborted by' },
  REASON: { key: 'REASON', value: 'Reason' },
  REJECT: { key: 'REJECT', value: 'Reject' },
  REJECT_CONFIRMATION: { key: 'REJECT_CONFIRMATION', value: 'Are you sure you want to reject this batch?' },
  ABORT_CONFIRMATION: { key: 'ABORT_CONFIRMATION', value: 'Are you sure you want to abort this batch?' },
  CANCEL: { key: 'CANCEL', value: 'Cancel' },
  RESCHEDULE: { key: 'RESCHEDULE', value: 'Reschedule' },
  RESCHEDULE_JOB: { key: 'RESCHEDULE_JOB', value: 'Reschedule Job' },
  NEW_DATE: { key: 'NEW_DATE', value: 'New Date' },
  NEW_TIME: { key: 'NEW_TIME', value: 'New Time' },
  SAVE_NEW_SCHEDULE: { key: 'SAVE_NEW_SCHEDULE', value: 'Save New Schedule' },
  BASIC_JOB_INFO: { key: 'BASIC_JOB_INFO', value: 'Basic Job Information' },
  CANCEL_JOB: { key: 'CANCEL_JOB', value: 'Cancel Job' },
  COMMUNICATION: { key: 'COMMUNICATION', value: 'Communication' },
  DATA_FILE_NAME: { key: 'DATA_FILE_NAME', value: 'Data File' },
  FETCH_DETAILS_ERROR: { key: 'FETCH_DETAILS_ERROR', value: 'Failed to fetch job details' },
  INITIATED_FROM: { key: 'INITIATED_FROM', value: 'Initiated From' },
  INITIATED_BY: { key: 'INITIATED_BY', value: 'Initiated By' },
  CONTINUE_DRAFT_ERROR: { key: 'CONTINUE_DRAFT_ERROR', value: "We're unable to edit this draft at the moment. Please try again later." },
  DRAFT_DISCARDED_MESSAGE: { key: 'DRAFT_DISCARDED_MESSAGE', value: 'Your draft has been successfully discarded.' },
  ENTER_EMAIL_PLACEHOLDER: { key: 'ENTER_EMAIL_PLACEHOLDER', value: 'Enter email and press Enter' },
};

export const PROOFS_TAB = {
  PROOFS_FETCH_FAILED: { key: 'PROOFS_FETCH_FAILED', value: 'Failed to fetch proofs info' },
}